// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-entity-page',
    // #endregion
    // #region Properties
    data: () => ({
        _self: null,
        _modals: [],
    }),
    // #endregion
    // #region Computed
    computed: {
        window() {
            return this._self;
        }
    },
    // #endregion
    // #region Constructor
    created() {
        this.updateWindows();
    },
    // #endregion
    // #region Watch
    watch: {
        "$route"(value) {
            this.updateWindows();
        },
    },
    // #endregion
    // #region Methods
    methods: {
        updateWindows() {
            let tEntity = this.$route.segments;
            {
                if (tEntity) {
                    this._self = tEntity.items.find(e => e.navigation.isActive && !e.navigation.isModal);
                    this._modals = tEntity.items.filter(e => e.navigation.isActive && e.navigation.isModal);
                }
            }
        }
    }
    // #endregion
});
// #endregion
